import Yup from '_zari/validation/_yup'

export default Yup.object().shape({
  codigo: Yup.string().required(),
  descripcion: Yup.string().required(),
  moneda: Yup.string().required()
})
